type AvailableFonts = 'main' | 'Montserrat';

export type Fonts = {
  [key in AvailableFonts]: string;
};

const fonts: Fonts = {
  Montserrat: 'var(--fonts-body)',
  main: 'var(--fonts-body)',
};

export default fonts;
